// import React, { useEffect, useState } from "react";

// export const Banner0 = ({ data }) => {
//   const component = data;
//   const banners = data["get_home_component_details"]["content"];

//   const [height, setHeight] = useState("");
//   const [heightm, setHeightm] = useState("");
//   const [padding, setPadding] = useState("");
//   const [margin, setMargin] = useState("");
//   const [radius, setRadius] = useState("");

//   useEffect(() => {
//     setHeight(component.web_height);
//     setHeightm(component.height);
//     setPadding(component.item_padding);
//     setMargin(component.item_margin);
//     setRadius(component.corner_radius);
//   }, [component.web_height, component.height]);

  
//   return (
//     <div>
//       {/* Desktop View */}
//       <div className="hidden md:block">
//         {banners.map((banner) => {
//           const file = banner.component_image || "";
//           const src = `https://grobizapp-n.s3.ap-south-1.amazonaws.com/slider/${file}`;
//           const ext = file.split(".").pop()?.toLowerCase();

//           return (
//             <div key={banner.component_auto_id}>
//               {["jpg", "jpeg", "png", "gif", "webp"].includes(ext) ? (
//                 <img
//                   src={src}
//                   alt="not found"
//                   className="w-full object-cover"
//                   style={{
//                     height: parseInt(height, 10) + "px",
//                     borderRadius: radius,
//                     margin: margin,
//                     padding: padding,
//                   }}
//                 />
//               ) : ["mp4", "webm", "ogg"].includes(ext) ? (
//                 <video
//                   src={src}
//                   controls
//                   autoPlay
//                   muted
//                   loop
//                   className="w-full object-cover"
//                   style={{
//                     height: parseInt(height, 10) + "px",
//                     borderRadius: radius,
//                     margin: margin,
//                     padding: padding,
//                   }}
//                 />
//               ) : ["mp3", "wav"].includes(ext) ? (
//                 <audio
//                   src={src}
//                   controls
//                   style={{
//                     width: "100%",
//                     height: parseInt(height, 10) + "px",
//                     borderRadius: radius,
//                     margin: margin,
//                     padding: padding,
//                   }}
//                 />
//               ) : (
//                 <p className="text-sm text-red-500">Unsupported file type</p>
//               )}
//             </div>
//           );
//         })}
//       </div>

//       {/* Mobile View */}
//       <div className="block md:hidden">
//         {banners.map((banner) => {
//           const file = banner.component_image || "";
//           const src = `https://grobizapp-n.s3.ap-south-1.amazonaws.com/slider/${file}`;
//           const ext = file.split(".").pop()?.toLowerCase();

//           return (
//             <div key={banner.component_auto_id}>
//               {["jpg", "jpeg", "png", "gif", "webp"].includes(ext) ? (
//                 <img
//                   src={src}
//                   alt="not found"
//                   className="w-full object-cover"
//                   style={{
//                     height: parseInt(heightm, 10) + "px",
//                     borderRadius: radius,
//                     margin: margin,
//                     padding: padding,
//                   }}
//                 />
//               ) : ["mp4", "webm", "ogg"].includes(ext) ? (
//                 <video
//                   src={src}
//                   controls
//                   autoPlay
//                   muted
//                   loop
//                   className="w-full object-cover"
//                   style={{
//                     height: parseInt(heightm, 10) + "px",
//                     borderRadius: radius,
//                     margin: margin,
//                     padding: padding,
//                   }}
//                 />
//               ) : ["mp3", "wav"].includes(ext) ? (
//                 <audio
//                   src={src}
//                   controls
//                   style={{
//                     width: "100%",
//                     height: parseInt(heightm, 10) + "px",
//                     borderRadius: radius,
//                     margin: margin,
//                     padding: padding,
//                   }}
//                 />
//               ) : (
//                 <p className="text-sm text-red-500">Unsupported file type</p>
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </div>

//   );
// };

import React, { useEffect, useState } from "react";

export const Banner0 = ({ data }) => {
  const component = data;
  const banners = data["get_home_component_details"]["content"];

  const [height, setHeight] = useState("");
  const [heightm, setHeightm] = useState("");
  const [padding, setPadding] = useState("");
  const [margin, setMargin] = useState("");
  const [radius, setRadius] = useState("");

  useEffect(() => {
    setHeight(component.web_height || "auto");
    setHeightm(component.height || "auto");
    setPadding(component.item_padding || "0");
    setMargin(component.item_margin || "0");
    setRadius(component.corner_radius || "0");
  }, [component]);

  const renderMedia = (file, isMobile) => {
    if (!file) return null;

    const ext = file.split(".").pop()?.toLowerCase();
    const src = `https://grobizapp-n.s3.ap-south-1.amazonaws.com/slider/${file}`;

    const style = {
      height: `${parseInt(isMobile ? height : height)}px`,
      borderRadius: radius,
      margin,
      padding,
    };

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) {
      return <img src={src} alt="banner" className="w-full object-cover" style={style} />;
    }

    if (["mp4", "webm", "ogg"].includes(ext)) {
      return <video src={src} controls autoPlay muted loop className="w-full object-cover" style={style} />;
    }

    if (["mp3", "wav"].includes(ext)) {
      return <audio src={src} controls style={{ ...style, width: "100%" }} />;
    }

    return <p className="text-red-500">Unsupported file type: {ext}</p>;
  };

  return (
    <div>
      {/* Desktop */}
      <div className="hidden md:block">
        {banners.map((banner, index) => (
          <div key={banner._id || index}>
            {renderMedia(banner.component_image, false)}
          </div>
        ))}
      </div>

      {/* Mobile */}
      <div className="block md:hidden">
        {banners.map((banner, index) => (
          <div key={banner._id || index}>
            {renderMedia(banner.component_image, true)}
          </div>
        ))}
      </div>
    </div>
  );
};
 